import React from 'react'

import OtherPlatformContainer from '@/views/Byecode/Application/[id]/OtherPlatforms'

export const otherPlatformsRoute = {
    path: 'otherPlatforms',
    element: <OtherPlatformContainer />
}
